import Papa from "papaparse";

export const handleCsvCaptailExtraction = async (file) => {
  return new Promise((resolve, reject) => {
    Papa.parse(file, {
      complete: (results) => {
        console.log()
        const formattedData = formatCsvData(results.data);
        resolve(formattedData);
      },
      error: (error) => {
        console.error("Error parsing CSV:", error);
        reject(error);
      },
      header: true, // Assuming your CSV has headers
      skipEmptyLines: true,
    });
  });
};

const formatCsvData = (csvData) => {
  return csvData
    .filter(item => item.Id && item.Id.trim() !== '')
    .map(item => ({
      "Id": item.Id || '',
      "Balance": item.Balance || '',
      "Amount": item.Amount || '',
      "Currency": item.Currency || '',
      "Type": item.Type || '',
      "Status": "PROCESSED",
      "Modified": item.Modified || '',
      "Trade Id": item['Trade Id'] || item.Id || '',
      "Instrument Symbol": item['Instrument Symbol'] || '',
      "Instrument Name": item['Instrument Name'] || '',
      "Commission": item.Commission || '',
      "Account type": "CAPITAL"
    }));
};